import React from "react";
import { motion } from "framer-motion";
import { Container, Section, Eyebrow, DisplayHeading, BodyCopy, Reveal } from "@/components/kit";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const STAGES = [
  { label: "Traditional governance", tone: "muted", items: ["Policies", "Registers", "Questionnaires", "Point-in-time evidence"] },
  { label: "Meira", tone: "brand", items: ["AI testing", "Risk + control mapping", "Evidence generation", "Traceability", "Continuous assurance"] },
  { label: "Verifiable outcome", tone: "gold", items: ["Trust Passport", "Assurance record", "Verifiable certificate", "Evidence-backed trust"] },
];

export default function Differentiation() {
  return (
    <Section id="differentiation" className="border-t border-line bg-panel-raised/30">
      <Container>
        <div className="max-w-3xl">
          <Reveal><Eyebrow tone="brand">Why Meira is different</Eyebrow></Reveal>
          <DisplayHeading className="mt-6 text-3xl leading-[1.1] sm:text-4xl md:text-5xl">
            Governance tools tell you what <span className="text-content-faint">should</span> be true.
            <br /><span className="text-gradient">Meira proves what is true.</span>
          </DisplayHeading>
          <Reveal i={1}>
            <BodyCopy className="mt-6">
              Meira connects AI testing, governance, evidence and assurance so trust can be traced —
              not merely claimed.
            </BodyCopy>
          </Reveal>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="mt-10 grid items-stretch gap-3 sm:mt-14 md:grid-cols-[1fr_auto_1.15fr_auto_1fr]">
          {STAGES.map((s, i) => (
            <React.Fragment key={s.label}>
              <motion.div
                variants={fadeUp}
                className={`flex h-full flex-col rounded-lg border p-5 sm:p-7 ${
                  s.tone === "brand" ? "border-brand/30 bg-gradient-to-b from-brand/8 to-transparent"
                    : s.tone === "gold" ? "border-gold/30 bg-gradient-to-b from-gold/8 to-transparent" : "border-line bg-panel-raised"
                }`}
              >
                <div className={`font-mono text-[10px] uppercase tracking-[0.2em] ${s.tone === "brand" ? "text-brand-soft" : s.tone === "gold" ? "text-gold" : "text-content-faint"}`}>{s.label}</div>
                <div className="mt-5 flex flex-col gap-2.5">
                  {s.items.map((it) => (
                    <div key={it} className="flex items-center gap-2.5 text-[14px] text-content-muted">
                      <span className={`h-1 w-1 rounded-full ${s.tone === "brand" ? "bg-brand-soft" : s.tone === "gold" ? "bg-gold" : "bg-content-faint"}`} />
                      {it}
                    </div>
                  ))}
                </div>
              </motion.div>
              {i < STAGES.length - 1 && (
                <div className="flex items-center justify-center py-1 md:py-0">
                  <span className="text-content-faint">
                    <svg width="30" height="12" viewBox="0 0 30 12" fill="none" className="rotate-90 md:rotate-0"><path d="M0 6h26m0 0l-5-5m5 5l-5 5" stroke="currentColor" strokeWidth="1" /></svg>
                  </span>
                </div>
              )}
            </React.Fragment>
          ))}
        </motion.div>
      </Container>
    </Section>
  );
}
